import { render, staticRenderFns } from "./ExamsLogs.vue?vue&type=template&id=1860fc08"
import script from "./ExamsLogs.vue?vue&type=script&lang=js"
export * from "./ExamsLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports